var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrashIcon = function SvgTrashIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.534 5.5h2.928c.085 0 .163.04.21.112l.594.888H9.734l.594-.888a.26.26 0 0 1 .21-.112zm5.535 1-1.147-1.722A1.76 1.76 0 0 0 13.466 4h-2.932c-.584 0-1.13.294-1.456.778L7.931 6.5H5.75a.75.75 0 0 0-.75.75c0 .416.334.75.75.75h.362l.75 10.147A2 2 0 0 0 8.857 20h6.285c1.047 0 1.915-.81 1.993-1.853L17.887 8h.363c.416 0 .75-.334.75-.75a.75.75 0 0 0-.75-.75h-2.181m.315 1.5-.743 10.038a.5.5 0 0 1-.5.462H8.856a.503.503 0 0 1-.5-.462L7.616 8z"
  })));
};
export default SvgTrashIcon;